import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ICardData, IDataPersonal, IPages, IPlan } from "..";
import IconButton from "../../../components/IconButton";
import Input from "../../../components/Input";
import { remask, unRemask } from "../../../libs/remask-mask";
import "./index.scss";
import logoWithoutName from "../../../image/logoContrastWithoutName.svg";
import Button from "../../../components/Button";
import { toastError, toastWarn } from "../../../components/Toast";
import { Toaster } from "react-hot-toast";
import { IconLeftArrowVersion2 } from "../../../icons";
import { serviceUsers } from "../../Collaborator/service";
import { createClientGatewayPay, createSubscriptionGatewayPay, getClientGatewayPay, getIpClient, getSystemCost, valueByUser } from "../service";
import useAuthData from "../../../hook/useAppData";
import { Success, Validating, Error } from "../StatusPages";
import { useHistory } from "react-router-dom";
import { postLogin } from "../../../page/auth/service/service";

export const Card = ({
  page,
  plan,
  setPage,
  cardData,
  setCardData,
  dataPersonal,
}: {
  page: IPages;
  plan: IPlan;
  setPage: Dispatch<SetStateAction<IPages>>;
  cardData: ICardData;
  setCardData: Dispatch<SetStateAction<ICardData>>;
  dataPersonal: IDataPersonal;
}) => {
  const { token, logindata, setToken } = useAuthData();
  const history = useHistory();

  const updateValue = (target) => {
    setCardData({
      ...cardData,
      [target.name]: target.value,
    });
  };

  const verefyDatasAndNext = () => {
    let quantityFieldsEmpty = 0;
    for (let field in cardData) {
      if (!cardData[field]) quantityFieldsEmpty++;
    }
    if (quantityFieldsEmpty) return toastWarn("Preencha os campos para continuar");
    return finishedSubscription();
  };

  const finishedSubscription = async () => {
    const subscriptionCreated = await createSubscription();
    if (!subscriptionCreated?.ok) return alterPage("Error");
    const resLogin = await postLogin(logindata);
    if (resLogin.ok) await successLogin(resLogin);
    return alterPage("Success");
  };

  const successLogin = async (resLogin: Response) => {
    const resLoginJson = await resLogin.json();
    setToken(`Bearer ${resLoginJson.token}`);
  };

  const alterPage = (page: IPages) => {
    setPage(page);
    setTimeout(() => {
      history.goBack();
    }, 4000);
  };

  const createSubscription = async () => {
    setPage("Validating");
    const cost = await valueByUser(plan, token);

    const { ip: ipClient } = await getIpClient();
    const bodyNewClient = {
      name: dataPersonal?.name,
      cpfCnpj: unRemask(dataPersonal?.cpfCnpj),
      email: dataPersonal?.email,
      mobilePhone: unRemask(dataPersonal?.phone),
      postalCode: unRemask(dataPersonal?.postalCode),
      addressNumber: dataPersonal.addressNumber,
      complement: dataPersonal?.complement,
    };
    const bodyNewSubscription = {
      billingType: "CREDIT_CARD",
      value: +cost?.toFixed(2),
      nextDueDate: nextDueDate(),
      cycle: "MONTHLY",
      creditCard: {
        holderName: cardData?.nameCard,
        number: unRemask(cardData?.numberCard),
        expiryMonth: cardData?.monthCard,
        expiryYear: "20" + cardData?.yearCard,
        ccv: cardData?.ccvCard,
      },
      creditCardHolderInfo: {
        name: dataPersonal?.name,
        email: dataPersonal?.email,
        cpfCnpj: dataPersonal?.cpfCnpj,
        postalCode: dataPersonal?.postalCode,
        addressNumber: dataPersonal?.addressNumber,
        phone: unRemask(dataPersonal?.phone),
      },
      remoteIp: ipClient,
      extraData: {
        plan,
      },
    };
    const resCreateSubscription = await createSubscriptionGatewayPay({ token, body: { bodyClient: bodyNewClient, bodyCard: bodyNewSubscription } });
    return resCreateSubscription;
  };

  const nextDueDate = () => {
    const isLastMonth = new Date().getMonth() === 11;
    if (isLastMonth) {
      return `${new Date().getFullYear() + 1}-01-05`;
    }
    return `${new Date().getFullYear()}-${String(new Date().getMonth() + 2).padStart(2, "0")}-05`;
  };

  const goBack = () => setPage("VerefyData");

  return (
    <>
      {page === "Card" && (
        <div className="box-form p-8 gap-8" onKeyPressCapture={(e) => (e.code === "Enter" ? verefyDatasAndNext() : null)}>
          <div className="flex items-center w-full justify-center">
            <IconButton icon={IconLeftArrowVersion2} className="" onClick={goBack} />
            <span className="text-2rem">Preencha os dados do seu cartão de crédito para dar continuidade no processo</span>
          </div>
          <div className="box-form-card-credit flex items-center h-full w-full gap-8">
            <CardCredit cardData={cardData} updateValue={updateValue} />
            <div className="box-next-payment flex flex-row items-end gap-8 ">
              <Button className="bg-blue-100 border-primary text-primary" onClick={goBack}>
                Cancelar
              </Button>
              <Button onClick={verefyDatasAndNext} className="bg-primary">
                Finalizar
              </Button>
            </div>
          </div>
        </div>
      )}
      {page === "Validating" && <Validating />}
      {page === "Success" && <Success />}
      {page === "Error" && <Error />}
    </>
  );
};

const CardCredit = ({ cardData, updateValue }: { cardData; updateValue: ({ name: string, value: any }) => void }) => {
  const verefyMonth = (target: { name: string; value: any }) => {
    if ((target.value > 12 || target.value < 1) && target.value?.length) return toastWarn("Mês inválido");
    updateValue(target);
  };

  const verefyYear = (target: { name: string; value: any }) => {
    const yearInTwoNumber = new Date().getFullYear().toString().substr(2, 2);
    if (+target.value < +yearInTwoNumber && target.value?.length > 1) return toastWarn("O ano deve ser maior que o ano atual");
    updateValue(target);
  };

  return (
    <>
      <Toaster />
      <div className="card-credit bg-primary w-4/6 p-5 rounded-3xl flex flex-col">
        <div className="bg-black -mx-5 mt-8 h-20 px-5 flex justify-end">
          {logoWithoutName ? <img src={logoWithoutName} alt="logoWithouName" className="w-20 " /> : ""}
        </div>
        <div className="flex flex-col justify-around h-full mt-2">
          <div className="flex flex-col justify-evenly h-full">
            <Input
              label="Número"
              name={"numberCard"}
              placeholder={"0000 0000 0000 0000"}
              value={cardData?.numberCard ? remask(cardData?.numberCard, ["9999 9999 9999 9999"]) : cardData?.numberCard}
              setValue={(e) => (e.target.value?.length < 20 ? updateValue(e.target) : null)}
              className="numberCard"
              maxLength={20}
              autoFocus
            />
            <Input
              label="Nome do titular"
              name={"nameCard"}
              placeholder={"INSIRA O NOME COMPLETO DO TITULAR DO CARTÃO"}
              value={cardData?.nameCard?.toUpperCase()}
              setValue={(e) => updateValue(e.target)}
              className="nameCard"
            />
          </div>
          <div className="flex justify-end gap-8">
            <Input
              label="CVV"
              name={"ccvCard"}
              placeholder={"000"}
              value={cardData?.ccvCard}
              setValue={(e) => updateValue(e.target)}
              className="ccv"
              maxLength={3}
            />
            <div className="flex items-center">
              <Input
                name={"monthCard"}
                label={"Mês"}
                placeholder={"00"}
                value={cardData?.monthCard}
                setValue={(e) => verefyMonth(e.target)}
                onBlur={(e) => verefyMonth({ name: e.target.name, value: e.target.value?.padStart(2, "0") })}
                className="validity"
                maxLength={2}
              />
              <span className="-mb-5">/</span>
              <Input
                name={"yearCard"}
                label={"Ano"}
                placeholder={"00"}
                value={cardData?.yearCard}
                setValue={(e) => verefyYear(e.target)}
                className="validity"
                maxLength={2}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
